import { render, staticRenderFns } from "./ModalEditBanner.vue?vue&type=template&id=6bb468dc&scoped=true"
import script from "./ModalEditBanner.vue?vue&type=script&lang=js"
export * from "./ModalEditBanner.vue?vue&type=script&lang=js"
import style0 from "./ModalEditBanner.vue?vue&type=style&index=0&id=6bb468dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb468dc",
  null
  
)

export default component.exports